import { render, staticRenderFns } from "./MultiDocumentKindListSelectorDialog.vue?vue&type=template&id=05081f87&scoped=true&"
import script from "./MultiDocumentKindListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiDocumentKindListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiDocumentKindListSelectorDialog.vue?vue&type=style&index=0&id=05081f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05081f87",
  null
  
)

export default component.exports